export enum ProjectStatus {
  Open,
  Closed,
}

export const displayReadableStatus = (value: ProjectStatus) => {
  switch (value) {
    case ProjectStatus.Open:
      return 'Open';
    case ProjectStatus.Closed:
      return 'Closed';
  }
};
